export default "__VITE_ASSET__b33c691d__"